import { render, staticRenderFns } from "./ChecklistYesVirus.vue?vue&type=template&id=65362ee1&scoped=true&"
import script from "./ChecklistYesVirus.vue?vue&type=script&lang=js&"
export * from "./ChecklistYesVirus.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistYesVirus.vue?vue&type=style&index=0&id=65362ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65362ee1",
  null
  
)

export default component.exports